; (function ($) {

	const QueryLoop = {

		init() {
			$(document).ready(() => {
				this.submitOnFilterChange();
				this.autosubmitOnKeywordChange();
			});
		},
		
		submitOnFilterChange() {
			const filters = document.querySelector('.query-loop .query-loop__filter');
			if (!filters) {
				return;
			}
			filters.addEventListener('change', () => {
				const form = filters.closest('form');
				if (form) {
					form.requestSubmit();
				}
			});
		},
		
		autosubmitOnKeywordChange() {
			const searchForm = document.querySelector('.query-loop__filter-form');
			const searchInput = document.getElementById('search');
			if (!searchForm) {
				return;
			}
			if (!searchInput) {
				return;
			}

			let initialValue = searchInput.value;

			const submitSearchForm = function () {
				if (typeof searchForm.requestSubmit === 'function') {
					searchForm.requestSubmit();
					return;
				}

				searchForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
			};

			searchInput.addEventListener('focus', function () {
				initialValue = searchInput.value;
			});

			searchInput.addEventListener('blur', function () {
				if (searchInput.value !== initialValue && searchInput.value.trim() !== '') {
					submitSearchForm();
				}
			});
			
			searchInput.addEventListener('input', function () {
				if (searchInput.value.trim() === '') {
					submitSearchForm();
				}
			});
		}

	};

	//Scope to just post query loops
	if (document.querySelector('.query-loop--post')) {
		QueryLoop.init();
	}

}(jQuery));